// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609111509/js/" + chunkId + "." + {"44":"f1d1dfe3","225":"a2fa889f","481":"6aca0a5c","486":"bd001097","770":"a8982e2b"}[chunkId] + ".0.13278896193497303.chunk.js";
};